// extracted by mini-css-extract-plugin
export default {"load-more-loader__container":"styles_load-more-loader__container__EdREK"};